import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getResidentials = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetResidentialTypes}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useResidentialsQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetResidentialTypes],
    queryFn: () => getResidentials(companyCode),
  });
};
